/**
 * Names inside a notification's message.
 *
 * An activity's or step's title inside running text needs setting apart, or a
 * long one runs into the sentence around it: "Form a Thesis Committee — Submit
 * proposed committee members has been approved" reads as one long clause.
 * Every place that shows a message sets a marked name in italics, as the audit
 * log does for step names.
 *
 * A message is stored as a plain string, so the mark is a pair of characters
 * from the Unicode private-use area around the name: nothing a person types,
 * and stripped from the name itself so a title cannot open or close a mark of
 * its own. A message written before this has no marks and shows as it always
 * did.
 *
 * Shared by the backend, which writes messages, and the digest and the app,
 * which read them.
 */
const OPEN = "";
const CLOSE = "";

/** A name, marked for setting apart inside a message. */
export function named(text: string): string {
  return OPEN + text.replaceAll(OPEN, "").replaceAll(CLOSE, "") + CLOSE;
}

/** A message as runs of text, each saying whether it is a name. */
export function messageParts(message: string): Array<{ text: string; isName: boolean }> {
  const parts: Array<{ text: string; isName: boolean }> = [];
  let rest = message;
  while (rest !== "") {
    const open = rest.indexOf(OPEN);
    const close = open === -1 ? -1 : rest.indexOf(CLOSE, open);
    if (open === -1 || close === -1) {
      parts.push({ text: rest.replaceAll(OPEN, "").replaceAll(CLOSE, ""), isName: false });
      break;
    }
    if (open > 0) {
      parts.push({ text: rest.slice(0, open), isName: false });
    }
    parts.push({ text: rest.slice(open + 1, close), isName: true });
    rest = rest.slice(close + 1);
  }
  return parts;
}
